import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useMemo } from 'react';
import ReachAlert from '@reach/alert';
import { Text } from "../Text";
import styled from 'styled-components';
import { theme } from "../../theme";
import { IconCheckCircleFill } from "@frameio/vapor-icons/build/esm/icons/IconCheckCircleFill";
import { IconInfoFill } from "@frameio/vapor-icons/build/esm/icons/IconInfoFill";
import { IconWarningFill } from "@frameio/vapor-icons/build/esm/icons/IconWarningFill";
import { IconX } from "@frameio/vapor-icons/build/esm/icons/IconX";
import { IconXCircleFill } from "@frameio/vapor-icons/build/esm/icons/IconXCircleFill";
import { IconButton } from "../Button";
import { Box } from "../Box";
import { Separator } from "../Separator";
export function AlertInline(_ref) {
  var type = _ref.type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      _ref$closeButtonAcces = _ref.closeButtonAccessibilityLabel,
      closeButtonAccessibilityLabel = _ref$closeButtonAcces === void 0 ? 'Close' : _ref$closeButtonAcces,
      onRequestClose = _ref.onRequestClose,
      adornmentAfter = _ref.adornmentAfter,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'block' : _ref$display,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["type", "variant", "closeButtonAccessibilityLabel", "onRequestClose", "adornmentAfter", "display", "children"]);

  var _useMemo = useMemo(function () {
    switch (variant) {
      case 'error':
        return {
          icon: /*#__PURE__*/React.createElement(IconXCircleFill, {
            color: theme.colors.palette.alertError500
          }),
          color: theme.colors.palette.alertError900
        };

      case 'info':
        return {
          icon: /*#__PURE__*/React.createElement(IconInfoFill, {
            color: theme.colors.palette.skyBlue500
          }),
          color: theme.colors.palette.blue900
        };

      case 'success':
        return {
          icon: /*#__PURE__*/React.createElement(IconCheckCircleFill, {
            color: theme.colors.palette.alertSuccess500
          }),
          color: theme.colors.palette.alertSuccess900
        };

      case 'warning':
        return {
          icon: /*#__PURE__*/React.createElement(IconWarningFill, {
            color: theme.colors.palette.alertWarning500
          }),
          color: theme.colors.palette.alertWarning900
        };

      default:
        return {
          icon: null,
          color: theme.colors.background.component
        };
    }
  }, [variant]),
      icon = _useMemo.icon,
      color = _useMemo.color;

  function renderAdornmentAfter() {
    if (!onRequestClose && !adornmentAfter) {
      return null;
    }

    return /*#__PURE__*/React.createElement(AlertAdornments, null, adornmentAfter && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
      width: "16"
    }), adornmentAfter, /*#__PURE__*/React.createElement(Box, {
      width: "4"
    })), /*#__PURE__*/React.createElement(Separator, {
      color: "primary",
      gap: 8,
      vertical: true,
      height: "100%"
    }), /*#__PURE__*/React.createElement(IconButton, {
      label: closeButtonAccessibilityLabel,
      size: "small",
      onClick: onRequestClose,
      variant: "link",
      icon: /*#__PURE__*/React.createElement(IconX, {
        size: 16
      })
    }));
  }

  return /*#__PURE__*/React.createElement(StyledReachAlert, _extends({
    $display: display,
    $background: color,
    type: type
  }, other), /*#__PURE__*/React.createElement(AlertTextAndIcon, null, /*#__PURE__*/React.createElement(IconContainer, null, icon), /*#__PURE__*/React.createElement(Text, {
    variant: "caption",
    color: "primary"
  }, children)), renderAdornmentAfter());
}
var StyledReachAlert = styled(ReachAlert).withConfig({
  displayName: "AlertInline__StyledReachAlert",
  componentId: "vapor__xkhp9k-0"
})(["display:", ";align-items:center;background-color:", ";border-radius:", ";"], function (p) {
  return p.$display === 'inline' ? 'inline-flex' : 'flex';
}, function (p) {
  return p.$background;
}, theme.radii[4]);
var AlertTextAndIcon = styled.div.withConfig({
  displayName: "AlertInline__AlertTextAndIcon",
  componentId: "vapor__xkhp9k-1"
})(["padding:", ";padding-right:", ";display:flex;align-items:center;"], theme.spaces[8], theme.spaces[12]);
var IconContainer = styled.div.withConfig({
  displayName: "AlertInline__IconContainer",
  componentId: "vapor__xkhp9k-2"
})(["height:", ";flex-shrink:0;margin-right:", ";"], theme.spaces[24], theme.spaces[8]);
var AlertAdornments = styled.div.withConfig({
  displayName: "AlertInline__AlertAdornments",
  componentId: "vapor__xkhp9k-3"
})(["display:flex;align-items:center;align-self:stretch;margin-left:auto;padding-right:", ";flex-shrink:0;"], theme.spaces[8]);